// extracted by mini-css-extract-plugin
export var auto = "_46-1";
export var spinner = "_46-0";